import {React, useState, useEffect} from 'react';
import Grid from '@material-ui/core/Grid';
import SangerRowName from './SangerRowComponents/SangerRowName';
import SangerRowPrimers from './SangerRowComponents/SangerRowPrimers'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import IconButton from '@mui/material/IconButton';
import RemoveCircle from '@mui/icons-material/RemoveCircle';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import SangerRowPremix from './SangerRowComponents/SangerRowPremix'
import SangerRowConcentration from "./SangerRowComponents/SangerRowConcentration"
import SangerRowErrors from "./SangerRowComponents/SangerRowErrors"
import SangerRowWell from './SangerRowComponents/SangerRowWell'
import SangerRowReadLen from './SangerRowComponents/SangerRowReadLen';
import SangerRowVol from './SangerRowComponents/SangerRowVol';
import SangerRowType from './SangerRowComponents/SangerRowType';
import SangerRowDesiredTemplate from './SangerRowComponents/SangerRowDesiredTemplate';



const SangerRowComponent = (props) => {
    const data = props.data;
    const index = props.index;
    const updateSample = props.updateSample;
    const primers= props.primers
    const primerColors= props.primerColors;
    const primerMapToList= props.primerMapToList;
    const removeSample = props.removeSample;
    const addNewSampleIndex = props.addNewSampleIndex;
    const submitShowError = props.submitShowError;
    const showAllErrors = props.showAllErrors;
    const formik = props.formik;

    function isNumeric(str) {
        return /^\+?\d+$/.test(str);
      }
      
      function errorConc(concVal) {
        return (concVal < 5) || (!isNumeric(concVal)) || (concVal == null || concVal == '');
      }
      
      function errorName(string) {
        return (string.length > 70) || (string.trim().length === 0) || (string.length <= 5);
      }
      
      function errorPrimers(primers, premixed) {
        return !premixed && primers.length < 1;
      }
      
      function errorReadLen(readLength) {
        return (readLength === undefined || readLength === null) || (!isNumeric(readLength)) || (readLength < 0) || (readLength > 800);
      }
      
      function errorVol(vol, primerRowList, premixed) {
        let requiredVol = (premixed ? 10 : (primerRowList.length == 0 ? 1 : primerRowList.length) * 10);
        return (vol == null || vol == '') || (!isNumeric(vol)) || (vol < requiredVol);
      }
      

    const [templateOptions, setTemplateOptions] = useState([]);

    const updateTemplateOptions = (type) => {
      let options;
      if (type === 'DNA' || type === 'Plasmid-insert') {
        options = ['PCR Product: 100 - 200 bp', 'PCR Product: 200 - 500 bp', 'PCR Product: 500 - 1000 bp','PCR Product: 1000 - 2000 bp', 'PCR Product: >2000 bp']
      } else {
        options = ['Plasmid: Single-stranded', 'Plasmid: Double-stranded', 'Plasmid: Cosmid, BAC', 'Bacterial genomic DNA']
      }
      setTemplateOptions(options);
      return options;
    }

    useEffect(() => {
      updateTemplateOptions(data.type)
    }, [data.type, data.template])

    return (
        <div key={data.id}>
        <Grid container style={{paddingRight: 7, paddingLeft: 10, marginTop: 0, paddingTop: 0, marginBottom: 0}}>
                <SangerRowWell
                index={index}
                />
                <SangerRowName
                index={index}
                // key={data.id}
                id={data.id}
                data={data}
                updateSample={updateSample}
                errorName={errorName}
                />
                <SangerRowPrimers
                index={index}
                // key={data.id}
                id={data.id}
                data={data}
                updateSample={updateSample}
                primers={primers}
                primerColors={primerColors}
                primerMapToList={primerMapToList}
                errorPrimers={errorPrimers}
                />
                <SangerRowPremix
                id={data.id}
                data={data}
                index={index}
                updateSample={updateSample}
                />
                <SangerRowConcentration
                id={data.id}
                data={data}
                index={index}
                updateSample={updateSample}
                submitShowError={submitShowError}
                formik = {formik}
                errorConc ={errorConc}
                />
                <SangerRowReadLen
                id={data.id}
                data={data}
                index={index}
                updateSample={updateSample}
                errorReadLen={errorReadLen}
                />
                <SangerRowVol
                id={data.id}
                data={data}
                index={index}
                updateSample={updateSample}
                submitShowError={submitShowError}
                errorVol={errorVol}
                />
                <SangerRowType
                id={data.id}
                data={data}
                index={index}
                updateSample={updateSample}
                submitShowError={submitShowError}
                updateTemplateOptions={updateTemplateOptions}
                />
                <SangerRowDesiredTemplate
                id={data.id}
                data={data}
                index={index}
                updateSample={updateSample}
                templateOptions={templateOptions}
                submitShowError={submitShowError}
                updateTemplateOptions={updateTemplateOptions}
                />
                <Grid>
                <IconButton onClick={() => addNewSampleIndex(props.id)}>
                <AddCircleIcon/>
                </IconButton>
                </Grid>
                <Grid>
                <IconButton onClick={() => removeSample(props.id)}>
                <RemoveCircle/>
                </IconButton>
                </Grid>
                <SangerRowErrors
                id={data.id}
                data={data}
                index={index}
                updateSample={updateSample}
                submitShowError={submitShowError}
                showAllErrors={showAllErrors}
                formik = {formik}
                errorConc ={errorConc}
                isNumeric={isNumeric}
                errorName={errorName}
                errorPrimers={errorPrimers}
                errorReadLen={errorReadLen}
                errorVol={errorVol}
                />
                </Grid>
            </div>
      );
    }

export default SangerRowComponent;
